import work_2 from "../assets/work-2.png";
import work_1 from "../assets/work-1.png";
import work_3 from "../assets/work-3.png";
import work_7 from "../assets/work-7.png";
import work_9 from "../assets/work-9.png";

import ReactPlayer from "react-player";

export const Portfolio = () => {
  return (
    <section className="section" id="portfolio">
      <h2 className="section_title">Portfolio</h2>
      <span className="section_subtitle">Most recent work</span>

      <div className="portfolio_container">
        <div className="container">
          {/* ================ PROJECT 1.2 ================ */}
          <div className="portfolio_project-first">
            <div className="portfolio_project-container">
              <div className="portfolio_project-description">
                <h1>ProdVision</h1>
                <span>OpenCV • NumPy </span>
                <p>
                  ProdVision – A Python-based, real-time object detection and
                  counting system for production lines, built using OpenCV. This
                  solution employs background subtraction and contour detection
                  instead of pre-trained models, minimizing computational
                  overhead. Automatically tracks items via bounding boxes and
                  updates counts in real time, offering a straightforward
                  approach to streamline production monitoring.
                </p>
                <div className="portfolio_project-links">
                  <div>
                    <a
                      href="https://github.com/polinamenshikova/ProdVision"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      Code
                      <i className="uil uil-github button_icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="portfolio_project-player">
                <div className="video-wrapper">
                  <ReactPlayer
                    url="https://www.youtube.com/watch?v=FIpdoaEOKW4"
                    width="100%"
                    height="100%"
                    controls
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ================ PROJECT 1.3 ================ */}
          <div className="portfolio_project-first">
            <div className="portfolio_project-container">
              <div className="portfolio_project-description">
                <h1>Summify</h1>
                <span>OpenAI • Python • Telegram</span>
                <p>
                  Summify – An AI-powered text summarization tool built using
                  OpenAI's GPT and integrated with Telegram for seamless access.
                  This Python-based solution quickly condenses long-form text
                  into concise, meaningful summaries, helping users extract key
                  insights effortlessly. With an intuitive Telegram bot
                  interface, Summify ensures fast, on-the-go summarization
                  without compromising accuracy or readability.
                </p>
                <div className="portfolio_project-links">
                  <div>
                    <a
                      href="https://t.me/summify_bot"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      Try It
                      <i className="uil uil-arrow-right button_icon" />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://github.com/polinamenshikova/Summify"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      Code
                      <i className="uil uil-github button_icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="portfolio_project-player">
                <div className="video-wrapper">
                  <ReactPlayer
                    url="https://www.youtube.com/watch?v=P-KMsJZOCyg"
                    width="100%"
                    height="100%"
                    controls
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ================ PROJECT 1.1 ================ */}
          <div className="portfolio_project-first">
            <div className="portfolio_project-container">
              <div className="portfolio_project-description">
                <h1>Virlama</h1>
                <span>Vite.js • Cloudflare </span>
                <p>
                  Welcome to Virlama – your hub for home, beauty, and lifestyle
                  inspiration! Built on Vite.js and deployed on Cloudflare, our
                  platform offers a seamless experience. Discover stunning decor
                  ideas, expert beauty tips, lifestyle hacks, and delicious
                  recipes powered by Cloudflare’s database. Whether refreshing
                  your space, enhancing self-care, or cooking something special,
                  Virlama is your guide to effortless elegance!
                </p>
                <div className="portfolio_project-links">
                  <div>
                    <a
                      href="https://virlama.com/"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      View More
                      <i className="uil uil-arrow-right button_icon" />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://github.com/polinamenshikova/Virlama"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      Code
                      <i className="uil uil-github button_icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="portfolio_project-img">
                <img src={work_9} style={{ width: "396px", height: "338px" }} />
              </div>
            </div>
          </div>

          {/* ================ PROJECT 1 ================ */}
          <div className="portfolio_project-first">
            <div className="portfolio_project-container">
              <div className="portfolio_project-description">
                <h1>Cou Cou</h1>
                <span>React • Redux </span>
                <p>
                  Welcome to "Cou Cou" – your stylish online clothing shop!
                  Powered by React and Tailwind frameworks, we bring you an
                  innovative shopping experience. Explore our curated collection
                  of trendy fashion, carefully crafted to keep you ahead of the
                  fashion curve. With our sleek interface and secure
                  transactions, shopping at "Cou Cou" is effortless.
                </p>
                <div className="portfolio_project-links">
                  <div>
                    <a
                      href="https://cou-cou.pages.dev/"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      View More
                      <i className="uil uil-arrow-right button_icon" />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://github.com/polinamen132132/Cou-Cou"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      Code
                      <i className="uil uil-github button_icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="portfolio_project-img">
                <img src={work_7} style={{ width: "396px", height: "338px" }} />
              </div>
            </div>
          </div>

          {/* ================ PROJECT 2 ================ */}
          <div className="portfolio_project-first">
            <div className="portfolio_project-container">
              <div className="portfolio_project-description">
                <h1>Finsecure</h1>
                <span>UI/UX • Figma</span>
                <p>
                  Finsecure is a robust banking app that provides a secure and
                  convenient way to manage your finances. With Finsecure, you
                  can easily access your accounts, make transactions, and stay
                  on top of your financial goals.
                </p>
              </div>
              <div className="portfolio_project-img">
                <img src={work_2} style={{ width: "396px", height: "338px" }} />
              </div>
            </div>
          </div>

          {/* ================ PROJECT 3 ================ */}
          {/* <div className="portfolio_project-second">
            <div className="portfolio_project-container">
              <div className="portfolio_project-description">
                <h1>YouTube Grabber</h1>
                <span>Back-end </span>
                <p>
                  YouTube Grabber is a Telegram bot built with Python, enabling
                  easy downloads of YouTube videos directly to your device. Just
                  send a video link, and receive a link to download a file.
                  Ideal for both mobile and desktop users.
                </p>
                <div className="portfolio_project-links">
                  <div>
                    <a
                      href="https://t.me/YTGrabberBot_bot"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      View More
                      <i className="uil uil-arrow-right button_icon" />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://github.com/polinamen132132/YTGrabberBot"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      Code
                      <i className="uil uil-github button_icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="portfolio_project-img">
                <img src={work_8} style={{ width: "159px", height: "340px" }} />
              </div>
            </div>
          </div> */}

          {/* ================ PROJECT 3 ================
          <div className="portfolio_project-second">
            <div className="portfolio_project-container">
              <div className="portfolio_project-description">
                <h1>Visio Scan</h1>
                <span>Back-end Developer</span>
                <p>
                  Visio Scan is an intelligent AI bot on Telegram. It uses
                  Python to analyze user-sent images, recognizing text, objects,
                  and patterns. Simply send an image to it, and it will provide
                  you with analysis and insights.
                </p>
                <div className="portfolio_project-links">
                  <div>
                    <a
                      href="https://t.me/ChatChipan_bot"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      View More
                      <i className="uil uil-arrow-right button_icon" />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://github.com/polinamen132132/Visio-Scan"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      Code
                      <i className="uil uil-github button_icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="portfolio_project-img">
                <img src={work_6} style={{ width: "159px", height: "340px" }} />
              </div>
            </div>
          </div> */}

          {/* ================ PROJECT 4================ */}
          <div className="portfolio_project-second">
            <div className="portfolio_project-container">
              <div className="portfolio_project-description">
                <h1>YumDrop</h1>
                <span>UI/UX • Figma</span>
                <p>
                  YumDrop makes it easy to order delicious meals from your
                  favorite local restaurants. With a user-friendly interface and
                  lightning-fast delivery service, YumDrop ensures a hassle-free
                  experience, bringing delectable dishes straight to your
                  doorstep.
                </p>
              </div>
              <div className="portfolio_project-img">
                <img src={work_1} style={{ width: "415px", height: "366px" }} />
              </div>
            </div>
          </div>

          {/* ================ PROJECT 5 ================ */}
          {/* <div className="portfolio_project-first">
            <div className="portfolio_project-container">
              <div className="portfolio_project-description">
                <h1>Birthday Beacon</h1>
                <span>Back-end </span>
                <p>
                  Birthday Beacon is a Python bot for Telegram. Store important
                  dates, like birthdays, of friends and family, and get timely
                  reminders. Don't miss celebrating special moments with loved
                  ones.
                </p>
                <div className="portfolio_project-links">
                  <div>
                    <a
                      href="https://t.me/Birthday_Beacon_bot"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      View More
                      <i className="uil uil-arrow-right button_icon" />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://github.com/polinamen132132/Birthday-Beacon"
                      className="button--flex button--small button--link portfolio_button-view"
                    >
                      Code
                      <i className="uil uil-github button_icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="portfolio_project-img">
                <img src={work_5} style={{ width: "159px", height: "340px" }} />
              </div>
            </div>
          </div> */}
          {/* ================ PROJECT 6 ================ */}
          <div className="portfolio_project-third">
            <div className="portfolio_project-container">
              <div className="portfolio_project-description">
                <h1>StyleHub</h1>
                <span>UI/UX • Figma </span>
                <p>
                  StyleHub is a stylish clothing app that combines fashion
                  inspiration with effortless shopping. With StyleHub, you can
                  explore the latest trends, create your dream outfits, and
                  conveniently order clothes from the comfort of your own home.
                </p>
              </div>
              <div className="portfolio_project-img">
                <img src={work_3} style={{ width: "290px", height: "429px" }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
